import { React, useState, useRef } from "react";
import { useParams } from "react-router-dom";

const MarketAnalysisTie = ({ tieData, tieBookData }) => {

  const { marketId } = useParams();
  let r1b = "";
  let r1l = "";
  let rate1 = "";
  let rate2 = "";
  let r2b = "";
  let r2l = "";
  let rate3 = "";
  let rate4 = "";

  if (tieData !== null && tieData !== undefined) {
    r1b = tieData.r1b;
    r1l = tieData.r1l;
    rate1 = tieData.rate1;
    rate2 = tieData.rate2;
    r2b = tieData.r2b;
    r2l = tieData.r2l;
    rate3 = tieData.rate3;
    rate4 = tieData.rate4;
  }

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div style={{ marginTop: "20px", background: "#e4e5e6" }}>
      <div style={{ width: "100%" }} className="card card-accent-success">
        <div className="row bg-gray-100 market-head">
          <div className="col-12">
            <strong className="site_family">Tied Match</strong> &nbsp;{" "}
            <span
              className="rules-badge"
              data-toggle="modal"
              data-target="#userDetailModal"
              onClick={() => {
                const width = 1200;
                const height = 560;
                const left = window.screenX + (window.outerWidth - width) / 2;
                const top = window.screenY + (window.outerHeight - height) / 2;

                window.open(
                  `/agent/user-book/${marketId}/5`,
                  "UserBookWindow",
                  `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
                );
              }}
            >
              <i className="fa fa-address-book"></i>
            </span>
          </div>
        </div>

        <div class="row runners">
          <div class="col-7 col-md-4" style={{ paddingTop: "3px" }}>
            <strong style={{ fontSize: "1rem" }} className="site_family">
              Yes
            </strong>{" "}
            <br />{" "}
            <span
              style={{
                display:
                  tieBookData == undefined ||
                  (tieBookData?.rnr1s == "" && tieBookData?.rnr2s == "")
                    ? "none"
                    : ""
              }}
            >
              <span
                className="site_family"
                style={{
                  fontWeight: "bold",
                  color: tieBookData?.rnr1s >= 0 ? "red" : "green"
                }}
              >
                {formatTruncate(Math.round((tieBookData?.rnr1s || 0) * -1))}
              </span>{" "}
            </span>{" "}
          </div>{" "}
          <div class="col-5 col-md-8 price">
            <div class="row">
              <div class="col-md-2 d-none d-md-block cta-back">
                <div id="b3-54600" class="col-12 price site_family">
                  {" "}
                </div>{" "}
                <div id="bs3-54600" class="col-12 size site_family">
                  {" "}
                </div>
              </div>{" "}
              <div class="col-md-2 d-none d-md-block cta-back">
                <div
                  id="b2-54600"
                  class="col-md-12 col-sm-12 price site_family"
                >
                  {" "}
                </div>{" "}
                <div
                  id="bs2-54600"
                  class="col-md-12 col-sm-12 size site_family"
                >
                  {" "}
                </div>
              </div>{" "}
              <div class="col-6 col-md-2 cta-back">
                <div
                  id="b1-54600"
                  class="col-12 price site_family"
                  style={{ backgroundColor: "rgb(227, 248, 255)" }}
                >
                  {r1b}
                </div>{" "}
                <div
                  id="bs1-54600"
                  class="col-12 size site_family"
                  style={{ backgroundColor: "rgb(227, 248, 255)" }}
                >
                  {rate1}
                </div>
              </div>{" "}
              <div class="col-6 col-md-2 cta-lay">
                <div
                  id="l1-54600"
                  class="col-md-12 col-sm-12 price site_family"
                  style={{ backgroundColor: "rgb(255, 205, 204)" }}
                >
                  {r1l}
                </div>{" "}
                <div
                  id="ls1-54600"
                  class="col-md-12 col-sm-12 size site_family"
                  style={{ backgroundColor: "rgb(255, 205, 204)" }}
                >
                  {rate2}
                </div>
              </div>{" "}
              <div class="col-md-2 d-none d-md-block cta-lay">
                <div
                  id="l2-54600"
                  class="col-md-12 col-sm-12 price site_family"
                >
                  {" "}
                </div>{" "}
                <div
                  id="ls2-54600"
                  class="col-md-12 col-sm-12 size site_family"
                >
                  {" "}
                </div>
              </div>{" "}
              <div class="col-md-2 d-none d-md-block cta-lay">
                <div
                  id="l3-54600"
                  class="col-md-12 col-sm-12 price site_family"
                >
                  {" "}
                </div>{" "}
                <div
                  id="ls3-54600"
                  class="col-md-12 col-sm-12 size site_family"
                >
                  {" "}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row runners lastItemBorder">
          <div class="col-7 col-md-4" style={{ paddingTop: "3px" }}>
            <strong style={{ fontSize: "1rem" }} className="site_family">
              No
            </strong>{" "}
            <br />{" "}
            <span
              style={{
                display:
                  tieBookData == undefined ||
                  (tieBookData?.rnr1s == "" && tieBookData?.rnr2s == "")
                    ? "none"
                    : ""
              }}
            >
              <span
                className="site_family"
                style={{
                  fontWeight: "bold",
                  color: tieBookData?.rnr2s >= 0 ? "red" : "green"
                }}
              >
                {formatTruncate(Math.round((tieBookData?.rnr2s || 0) * -1))}
              </span>{" "}
            </span>{" "}
          </div>{" "}
          <div class="col-5 col-md-8 price">
            <div class="row">
              <div class="col-md-2 d-none d-md-block cta-back">
                <div id="b3-54600" class="col-12 price site_family">
                  {" "}
                </div>{" "}
                <div id="bs3-54600" class="col-12 size site_family">
                  {" "}
                </div>
              </div>{" "}
              <div class="col-md-2 d-none d-md-block cta-back">
                <div
                  id="b2-54600"
                  class="col-md-12 col-sm-12 price site_family"
                >
                  {" "}
                </div>{" "}
                <div
                  id="bs2-54600"
                  class="col-md-12 col-sm-12 size site_family"
                >
                  {" "}
                </div>
              </div>{" "}
              <div class="col-6 col-md-2 cta-back">
                <div
                  id="b1-54600"
                  class="col-12 price site_family"
                  style={{ backgroundColor: "rgb(227, 248, 255)" }}
                >
                  {r2b}
                </div>{" "}
                <div
                  id="bs1-54600"
                  class="col-12 size site_family"
                  style={{ backgroundColor: "rgb(227, 248, 255)" }}
                >
                  {rate3}
                </div>
              </div>{" "}
              <div class="col-6 col-md-2 cta-lay">
                <div
                  id="l1-54600"
                  class="col-md-12 col-sm-12 price site_family"
                  style={{ backgroundColor: "rgb(255, 205, 204)" }}
                >
                  {r2l}
                </div>{" "}
                <div
                  id="ls1-54600"
                  class="col-md-12 col-sm-12 size site_family"
                  style={{ backgroundColor: "rgb(255, 205, 204)" }}
                >
                  {rate4}
                </div>
              </div>{" "}
              <div class="col-md-2 d-none d-md-block cta-lay">
                <div
                  id="l2-54600"
                  class="col-md-12 col-sm-12 price site_family"
                >
                  {" "}
                </div>{" "}
                <div
                  id="ls2-54600"
                  class="col-md-12 col-sm-12 size site_family"
                >
                  {" "}
                </div>
              </div>{" "}
              <div class="col-md-2 d-none d-md-block cta-lay">
                <div
                  id="l3-54600"
                  class="col-md-12 col-sm-12 price site_family"
                >
                  {" "}
                </div>{" "}
                <div
                  id="ls3-54600"
                  class="col-md-12 col-sm-12 size site_family"
                >
                  {" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketAnalysisTie;
